<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-cut">
      Edit Email Snippet
    </PageTitle>

    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-text>
          <snippet-form :form="form">
          </snippet-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary"
                 type="submit">
            Update
          </v-btn>

          <v-btn :to="{name: `${$root.routePrefix}.snippets.index`}">
            Cancel
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn :to="{name: `${$root.routePrefix}.snippet.create`, query: {source: snippet.id}}">
            <v-icon left>
              fal fa-fw fa-copy
            </v-icon>
            Copy
          </v-btn>
          <v-btn color="error"
                 @click.prevent="deleteSnippet">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </v-container>
</template>
<script>
import snippetService from '../../services/snippetService';
import Form from 'vform';
import SnippetForm from "./components/SnippetForm";
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, SnippetForm},
  data() {
    return {
      busy: false,
      form: new Form({
        name: '',
        content: '',
        is_active: true,
      }),
      snippet: null,
    }
  },
  computed: {
    snippetID() {
      if (this.$route.params.snippetID) {
        return parseInt(this.$route.params.snippetID);
      }
      return null;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      snippetService.getSnippet(this.snippetID)
        .then(data => {
          this.snippet = data;
          this.form.name = data.name;
          this.form.is_active = data.is_active;
          this.form.content = data.content;
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 404) {
              this.$toast.error('Snippet not found.');
            }
          }
          this.$router.replace({name: `${this.$root.routePrefix}.snippets.index`});
        })
        .finally(() => {
          this.busy = false;
        })
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      snippetService.update(this.snippet.id, this.form)
        .then(data => {
          this.$router.push({name: `${this.$root.routePrefix}.snippets.index`});
        })
    },
    deleteSnippet() {
      if (confirm(`Are you sure you want to delete this snippet?`)) {
        snippetService.delete(this.snippetID)
          .then(() => {
            this.$router.push({name: `${this.$root.routePrefix}.snippets.index`});
          })
      }
    }
  },
}
</script>
